
import React, { useState } from 'react';

interface HeroProps {
  onBook: () => void;
}

const Hero: React.FC<HeroProps> = ({ onBook }) => {
  const [search, setSearch] = useState('');

  return (
    <section className="relative min-h-[80vh] flex items-center pt-32 pb-20 overflow-hidden bg-white">
      {/* Subtle geometric background patterns instead of photos */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#2E4A96]/[0.02] -skew-x-12 transform origin-top"></div>
      <div className="absolute bottom-0 left-0 w-1/4 h-2/3 bg-[#1CB496]/[0.02] skew-x-12 transform origin-bottom"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <div className="max-w-4xl mx-auto">
          <span className="inline-flex items-center px-5 py-2 mb-10 rounded-full bg-[#1CB496]/10 text-[#1CB496] text-xs font-black uppercase tracking-[0.2em] border border-[#1CB496]/20 shadow-sm">
            <span className="w-2 h-2 bg-[#1CB496] rounded-full mr-3 animate-pulse"></span>
            Hyper-Local Care in Whitefield & East Bangalore
          </span>
          
          <h1 className="text-5xl md:text-8xl font-black text-slate-900 mb-10 leading-[1.05] tracking-tight">
            The Gold Standard <br />
            <span className="text-[#2E4A96]">Home Healthcare</span> <br />
            <span className="text-[#1CB496]">Reimagined.</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-500 mb-12 leading-relaxed max-w-2xl mx-auto font-medium">
            Verified clinical expertise delivered with empathy. No delays, no complexity—just premium care for your loved ones, right where they are.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-14 max-w-2xl mx-auto">
            <div className="flex-grow relative group">
              <input 
                type="text" 
                placeholder="Enter your community (e.g. Prestige Lakeside)"
                className="w-full bg-slate-50 border border-slate-200 text-slate-900 rounded-2xl px-8 py-6 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#1CB496] transition-all font-bold"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <button 
              onClick={onBook}
              className="bg-[#1CB496] hover:bg-[#158c75] text-white font-black px-12 py-6 rounded-2xl transition-all shadow-xl shadow-[#1CB496]/20 whitespace-nowrap text-lg"
            >
              Get Started
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-12 text-slate-400 font-bold text-xs uppercase tracking-[0.2em]">
            <div className="flex items-center">
              <svg className="w-5 h-5 text-[#2E4A96] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              30-Min Arrival
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 text-[#1CB496] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 12l2 2 4-4m5.618-4.016A3.33 3.33 0 0014.118 4H5.882a3.33 3.33 0 00-3.5 3.333c0 2.667 1.334 5.333 4 8 2.666 2.667 5.333 4 8 4 2.666 0 5.333-1.333 8-4 2.666-2.667 4-5.333 4-8a3.33 3.33 0 00-2.382-3.333z"></path></svg>
              Whitefield Verified
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 text-[#2E4A96] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
              Clinical Excellence
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
